// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {filter, get, includes, isEmpty} from 'lodash';

// Redux Actions
import * as servicesDataActions from '../actions/services-data-actions';
import {resetForm} from '../actions/form-data-actions';

// Configs
import servicesConfig from '../../config/services-config';

export default function searchHoc(WrappedComponent, servicesDataKey) {
    class Search extends Component {
        getChildContext() {
            const {
                push,
                resetForm,
                refreshServicesData,
                resetSort,
                servicesDataSearch,
                servicesUnregisterStore,
                setQuery,
                setSort,
            } = this.props;

            return {
                push,
                refreshServicesData: servicesDataKeyOption =>
                    refreshServicesData(servicesDataKeyOption || servicesDataKey),
                resetServiceData: actionShouldFetch => this.resetServiceData(actionShouldFetch),
                resetSort: (clearSorts, actionShouldFetch) => resetSort(servicesDataKey, clearSorts, actionShouldFetch),
                servicesDataKey,
                servicesDataSearch: () => servicesDataSearch(servicesDataKey),
                servicesUnregisterStore: () => servicesUnregisterStore(servicesDataKey),
                setQuery: query => setQuery(servicesDataKey, query),
                setSort: sortColumn => setSort(servicesDataKey, sortColumn),
                resetForm: (submitted, resetValues) => resetForm(servicesDataKey, submitted, resetValues),
            };
        }

        UNSAFE_componentWillMount() {
            const {servicesRegisterStore} = this.props;

            servicesRegisterStore(servicesDataKey);
        }

        // componentWillUnmount() {
        //     this.props.servicesUnregisterStore(servicesDataKey);
        // }

        getSearchData(searchData, searchFilter = {}) {
            const {targets, activeId} = searchFilter;
            let content = searchData;

            if (!isEmpty(targets) && activeId) {
                content = filter(content, record => {
                    const fieldValue = get(record, activeId);

                    return fieldValue && includes(targets, fieldValue);
                });
            }

            return content;
        }

        getComponentProps() {
            const {
                dashboardProps,
                dependentFormData,
                dependentSearchData,
                push,
                routerParams,
                servicesFormData,
                servicesSearchData,
            } = this.props;
            const {error, fetched, fetching, filter, query, searchData} = servicesSearchData;
            const {fetching: dependentFetching, searchData: dependentSearchValues} = dependentSearchData || {};
            const {values: formValues} = dependentFormData || {};

            return {
                ...this.props,
                activeRowKeys: get(servicesConfig, [servicesDataKey, 'activeRowKeys']),
                dependentSearchValues,
                error,
                fetched,
                fetching: fetching || dependentFetching,
                formValues,
                number: get(searchData, 'number', 0),
                numberOfElements: get(searchData, 'numberOfElements', 0),
                push,
                query,
                routerParams,
                searchData: this.getSearchData(searchData, filter),
                searchFilter: filter,
                servicesDataKey,
                servicesFormData,
                size: get(searchData, 'size', 0),
                sort: get(query, 'sort', []),
                totalElements: get(searchData, 'totalElements', 0),
                totalPages: get(searchData, 'totalPages', 0),
                dashboardProps,
            };
        }

        render() {
            const {servicesSearchData} = this.props;

            return !isEmpty(servicesSearchData) ? <WrappedComponent {...this.getComponentProps()} /> : null;
        }
    }

    //  resetServiceData = (actionShouldFetch = true) => {
    //      return Promise.all([
    //         this.props.resetForm(servicesDataKey, actionShouldFetch),
    //         this.props.resetServiceData(servicesDataKey, actionShouldFetch),
    //     ]);
    // };

    Search.propTypes = {
        activeRowValue: PropTypes.string,
        additionalProps: PropTypes.object,
        dashboardProps: PropTypes.object,
        dependentFormData: PropTypes.object,
        dependentSearchData: PropTypes.object,
        push: PropTypes.func.isRequired,
        refreshServicesData: PropTypes.func.isRequired,
        resetForm: PropTypes.func.isRequired,
        resetServiceData: PropTypes.func.isRequired,
        resetSort: PropTypes.func.isRequired,
        routerParams: PropTypes.object,
        servicesDataSearch: PropTypes.func.isRequired,
        servicesFormData: PropTypes.object,
        servicesRegisterStore: PropTypes.func.isRequired,
        servicesSearchData: PropTypes.object.isRequired,
        servicesUnregisterStore: PropTypes.func.isRequired,
        setQuery: PropTypes.func.isRequired,
        setSort: PropTypes.func.isRequired,
    };

    Search.childContextTypes = {
        push: PropTypes.func.isRequired,
        refreshServicesData: PropTypes.func.isRequired,
        resetServiceData: PropTypes.func.isRequired,
        resetSort: PropTypes.func.isRequired,
        servicesDataKey: PropTypes.string,
        servicesDataSearch: PropTypes.func.isRequired,
        servicesUnregisterStore: PropTypes.func.isRequired,
        setQuery: PropTypes.func.isRequired,
        setSort: PropTypes.func.isRequired,
        resetForm: PropTypes.func.isRequired,
    };

    function mapStateToProps(state) {
        const dependentServicesDataKey = get(servicesConfig, [servicesDataKey, 'dependentServicesDataKey']);
        const formName = get(servicesConfig, [servicesDataKey, 'formName']);

        return {
            dependentServicesDataKey,
            dependentSearchData: dependentServicesDataKey
                ? get(state.servicesSearchData, dependentServicesDataKey) || {}
                : undefined,
            formName,
            dependentFormData: formName ? get(state.formData, formName) || {} : undefined,
            routerParams: get(state.servicesSearchData, 'routerParams') || {},
            servicesFormData: get(state.formData, servicesDataKey) || {},
            servicesSearchData: get(state.servicesSearchData, servicesDataKey) || {},
        };
    }

    function mapDispatchToProps(dispatch) {
        return bindActionCreators({...servicesDataActions, push, resetForm}, dispatch);
    }

    return connect(mapStateToProps, mapDispatchToProps)(Search);
}
